var _ = require('underscore');
import { jaccardWeight } from './WeightFunctions';

function reduceObjectArray(arr) {
    return _.reduce(arr, function(memo, obj) {
        _.each(obj, function(value, key) {
            if (memo[key]) {
                memo[key] += value;
            } else {
                memo[key] = value;
            }
        });
        return memo;
    }, {});
}

function computeRatio(obj, weightFn) {
    const categories = Object.keys(obj);
    let weightedSum = 0;
    let total = 0;

    for (const a of categories) {
        total += obj[a];
        for (const b of categories) {
            weightedSum += weightFn(a, b) * obj[a] * obj[b];
        }
    }

    return weightedSum / Math.pow(total, 2);
}

function calculatePE(overlappingExcerpts, weightFn = jaccardWeight) {
    // for each excerpt
    const codeSize = overlappingExcerpts.map((excerpt) => {
        // return the code count multiplied by the size (end - start)
        return _.chain(excerpt.code_count).mapObject((value, key) => {
            return value * (excerpt.end - excerpt.start);
        }).value()
    })

    // sum the code sizes across all excerpts
    const codeSizeSum = reduceObjectArray(codeSize);
    const ratio = computeRatio(codeSizeSum, weightFn);
    return ratio;
}

export default calculatePE;
